import { useState } from "react";

import Typography from "@mui/joy/Typography";
import Stack from "@mui/joy/Stack";
import { BACKGROUND_GRADIENT_CSS } from '../constants';
import { ScreenContainerOnePotato } from "components/ScreenContainerPotato";

import Next from './PotatoNext';



export default function PotatoFancyHands({ onInView }: { onInView: (visibile: boolean, id: string) => boolean }) {
    const [introducing, setIntroducing] = useState(false);
    function introducingDayones() {
        setIntroducing(true);
        setTimeout(() => {
            setIntroducing(false);
        }, 525);
    }


    return (
        <ScreenContainerOnePotato
            view="introducing-dayones"
            onInView={onInView}
            onViewHook={() => introducingDayones()}
        // onInView={(inview) => onInView(inview, 'introducing-dayones')}
        >
            <Stack
                sx={{
                    opacity: 0.8,
                    minHeight: "400px",
                    backgroundSize: "cover",
                    backgroundPosition: "center",

                }}
                spacing={3}
            >

                <Typography
                    level="title-lg"
                    sx={{
                        backgroundImage: BACKGROUND_GRADIENT_CSS,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        backgroundClip: "text",
                        textFillColor: "transparent;",
                        textAlign: "center",
                        transition: 'all ease-in-out 0.3s',
                        // letterSpacing: introducing ? '-0.05rem' : 'normal',
                        // fontWeight: introducing ? 300 : 400,
                        filter: introducing ? 'brightness(1.80)' : 'brightness(1.0)',
                    }}
                >Introducing
                </Typography>
                <Typography

                    level="title-lg"
                    sx={{
                        backgroundImage: BACKGROUND_GRADIENT_CSS,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        fontWeight: "bold",
                        backgroundClip: "text",
                        textFillColor: "transparent;",
                        fontSize: { xs: "6rem", md: "12rem" },
                        textAlign: "center",
                        fontFamily: "'Oranienbaum', serif",
                        transition: 'all ease-in-out 0.4s',
                        letterSpacing: introducing ? '0.65rem' : 'normal',
                        filter: introducing ? 'brightness(1.45)' : 'brightness(1.0)',
                        //                                        textShadow: introducing ?  '0px 10px 5px white' : '0px 0px 0px white'
                    }}
                >Day Ones
                </Typography>
                <Next
                    nextId="what-is-day-ones"
                    ks="What is Day Ones?"
                />
            </Stack>
        </ScreenContainerOnePotato>

    );
}
